export const ERRORS = {
  AUTH_MM_API_SYNC_REQUIREMENT: `Modern Mirror API account registration needed`,
  AUTH_MM_API_SYNC_FAILED: `Error syncing with the Modern Mirror API`,
  AUTH_MM_API_LOGIN_FAILED: `Error logging into the Modern Mirror API`,
  AUTH_MM_API_INVALIDSESSION: 'AuthInvalidSession',
  AUTH_MM_API_NOSESSION: 'AuthNoSession',
  SYSTEM_ERROR: 'There is a system error, try again later',
  PERMISSION_ERROR: 'PermissionError',
};
